import { render, staticRenderFns } from "./MotorFinance.vue?vue&type=template&id=a5447a60&"
import script from "./MotorFinance.vue?vue&type=script&lang=js&"
export * from "./MotorFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports